import { render, staticRenderFns } from "./VGame.vue?vue&type=template&id=db161950&"
import script from "./VGame.vue?vue&type=script&lang=ts&"
export * from "./VGame.vue?vue&type=script&lang=ts&"
import style0 from "./VGame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports